import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Avatar } from '../components/ui/Avatar';
import { Badge } from '../components/ui/Badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/Card';
import { icons } from '../components/ui/Icons';
import { PageHeader } from '../components/layout/PageHeader';

export function ProfilePage() {
  const { user, discordRoles } = useAuth();
  const displayName = user?.discordDisplayName || user?.discordUsername || 'Klinikpersonal';

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <PageHeader
        title="Mein Profil"
        description="Zentrale Anzeige der aktuellen Anmelde- und Rolleninformationen."
        breadcrumbs={[{ label: 'Startseite', href: '/' }, { label: 'Mein Profil' }]}
      />

      <Card>
        <CardHeader className="flex flex-col gap-4 sm:flex-row sm:items-center">
          <Avatar src={user?.discordAvatar || undefined} name={displayName} size="lg" />
          <div className="min-w-0">
            <CardTitle className="text-xl">{displayName}</CardTitle>
            <CardDescription>@{user?.discordUsername || 'benutzer'} · Klinikpersonal</CardDescription>
          </div>
          <div className="sm:ml-auto">
            <Badge variant="medical" size="sm">Angemeldet</Badge>
          </div>
        </CardHeader>
        <CardContent>
          <dl className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
            <div>
              <dt className="text-xs font-medium uppercase tracking-wide text-neutral-500 dark:text-neutral-400">Discord-ID</dt>
              <dd className="mt-1 truncate font-mono text-sm text-neutral-900 dark:text-neutral-100">{user?.discordUserId || '-'}</dd>
            </div>
            <div>
              <dt className="text-xs font-medium uppercase tracking-wide text-neutral-500 dark:text-neutral-400">Discord-Rollen</dt>
              <dd className="mt-1 text-sm text-neutral-900 dark:text-neutral-100">{discordRoles.length || 0}</dd>
            </div>
            <div className="sm:col-span-2">
              <dt className="text-xs font-medium uppercase tracking-wide text-neutral-500 dark:text-neutral-400">Berechtigungen</dt>
              <dd className="mt-2 flex flex-wrap gap-2">
                {user ? (
                  <Badge variant="primary" size="sm">Session-basierte Berechtigungen geladen</Badge>
                ) : (
                  <Badge variant="gray" size="sm">Keine Benutzerdaten</Badge>
                )}
              </dd>
            </div>
          </dl>
        </CardContent>
      </Card>

      <Card variant="bordered">
        <CardContent className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-md bg-neutral-100 text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300">
              <icons.Info className="h-5 w-5" aria-hidden="true" />
            </div>
            <p className="text-sm text-neutral-600 dark:text-neutral-300">
              Personenstammdaten werden zentral verwaltet und hier nicht lokal verändert.
            </p>
          </div>
          <NavLink to="/einstellungen" className="inline-flex items-center gap-2 rounded-md border border-neutral-300 px-3 py-2 text-sm font-medium text-neutral-700 hover:bg-neutral-100 dark:border-neutral-600 dark:text-neutral-200 dark:hover:bg-neutral-800">
            <icons.Settings className="h-4 w-4" aria-hidden="true" />
            Persönliche Einstellungen
          </NavLink>
        </CardContent>
      </Card>
    </div>
  );
}
